export const MIN_CUIL = 20000000001;
export const MAX_CUIL = 27999999999;

export const ROLES = [
    {
        id: 1,
        nombre: 'ADMINISTRADOR_BACKOFFICE',
    },
    {
        id: 6,
        nombre: 'PREVENTOR',
    },
    {
        id: 4,
        nombre: 'ASEGURADORA_VIEWER',
    }
]

export const BACKOFFICE = 'BACKOFFICE';
export const ART = 'ART';
export const SIMP = 'SIMP';
export const PERFILES = [ART, SIMP];

export const GRV = 'GRV';

export const ERROR_CONTACT_SUPPORT = 'Intenta nuevamente, si el problema persiste, contactá a soporte.';
export const ALERT_CONFIRM_TEXT = 'Aceptar';
export const GENERIC_ERROR_TITLE = 'Ocurrió un error en el sistema';